module.exports = __webpack_public_path__ + "static/img/06_lea_cornelius_carstens.b1f546f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/lea/06_lea_cornelius_carstens.jpg
// module id = z3Gn
// module chunks = 1